// src/components/Layout.js
import React from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <Header />
      <main style={{ paddingTop: "72px" }}>
        <Outlet />
      </main>
    </>
  );
};

export default Layout;
